var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pipeline-filter"},[_c('h6',{staticClass:"pipeline-filter__label"},[_vm._t("label")],2),_c('div',{staticClass:"pipeline-filter__input"},[_vm._t("input")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }